export const MIN_DOCUMENT_NAME_LENGTH = 8;

export const MAX_DOCUMENT_NAME_LENGTH = 100;
